import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { YearPickerInput, DatesProvider } from '@mantine/dates';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const CPA_DGA = ({validation}) => {

    return (
        <React.Fragment>
            <div className='hstack justify-content-between mb-3'>
                <h5>CPA DGA</h5>                
                <p className="text-muted"></p>
            </div>
                
            <div>
                <Row className='gx-2 align-items-center'>
                    <Col className='mb-3'>
                        <Label for='certificate_number' className='form-label'>
                            N° Certificado   
                        </Label>
                        <Input
                            name='certificate_number'
                            id='certificate_number'
                            className='form-control'
                            placeholder='Ingrese el N° Certificado'
                            type='text'
                            value={validation.values.certificate_number || ''}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                        />
                    </Col>
                    <Col className='mb-3'>
                        <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                            <YearPickerInput
                                label='Año'
                                id='certificate_year'
                                name='certificate_year'
                                placeholder="Seleccione un año"
                                value={validation.values.certificate_year && !isNaN(Number(validation.values.certificate_year)) ? new Date(Number(validation.values.certificate_year), 0, 1) : null}
                                onChange={(date) => {
                                    // Extract only the year as number
                                    const year = date ? date.getFullYear() : null;
                                    validation.setFieldValue("certificate_year", year);
                                }}
                                onBlur={validation.handleBlur}
                                maxDate={new Date()}
                                error={
                                    validation.touched['certificate_year'] &&
                                        validation.errors['certificate_year']
                                        ? validation.errors['certificate_year'] : ''
                                }
                                clearable={true}
                            />
                        </DatesProvider>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default CPA_DGA;